import Vue from 'vue';
import ClickOutside from './click-outside';
import Sticky from './sticky';
import Protected from './protected';

Vue.directive('click-outside', ClickOutside);
Vue.directive('sticky', Sticky);
Vue.directive('protected', Protected);
